<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div class="flex items-center gap-4 px-5 py-4">
        <!-- Optional back button based on routing -->
        <!-- <button class="h-10 w-10 grid place-items-center rounded-2xl hover:bg-slate-50 active:scale-95 transition-all text-slate-700" (click)="toBack()">
          <span class="material-symbols-outlined text-slate-700">arrow_back</span>
        </button> -->
        <div class="flex-1">
          <h1 class="text-xl font-black text-slate-800 tracking-tight">{{ 'ชำระเงิน' | translate : 'payment' }}</h1>
          <p class="text-xs font-medium text-slate-500 mt-0.5">{{ 'สแกน QR Code เพื่อชำระค่าบริการ' | translate : 'payment' }}</p>
        </div>
      </div>
    </div>

    <div class="flex-1 overflow-y-auto w-full px-5 pt-5 pb-32 space-y-4">
      <!-- Total Amount Card -->
      <div
        class="rounded-3xl bg-gradient-to-br from-blue-600 to-indigo-600 p-6 shadow-lg shadow-blue-500/20 relative overflow-hidden">
        <!-- Decor pattern -->
        <div class="absolute -right-4 -top-4 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
        <div class="flex justify-between items-center relative z-10">
          <div>
            <div class="text-[13px] font-medium text-blue-100 mb-1 tracking-wide uppercase">{{ 'ยอดชำระเงินทั้งหมด' | translate : 'payment' }}</div>
            <div class="text-3xl font-black text-white flex items-baseline gap-1.5 drop-shadow-sm">
              {{ (bookingData()?.totalPrice ?? 0) | number }}
              <span class="text-sm font-semibold text-blue-200">THB</span>
            </div>
          </div>
          <div
            class="w-14 h-14 rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center shrink-0 border border-white/10">
            <span class="material-symbols-outlined text-white text-[28px]">payments</span>
          </div>
        </div>
      </div>

      <!-- QR Card -->
      <div class="bg-white rounded-3xl border border-slate-100 overflow-hidden shadow-sm">
        <!-- Card Header -->
        <div class="px-5 pt-4 pb-3 border-b border-slate-50 flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-xl bg-blue-50 flex items-center justify-center">
              <span class="material-symbols-outlined text-blue-500 text-[18px]">qr_code_2</span>
            </div>
            <div class="text-sm font-bold text-slate-800">{{ 'QR Code ชำระเงิน' | translate : 'payment' }}</div>
          </div>
          <!-- PromptPay Badge -->
          <div class="flex items-center gap-1.5 rounded-lg bg-slate-50 border border-slate-200 px-2.5 py-1">
            <div class="flex items-center gap-0.5">
              <div class="w-3.5 h-3.5 rounded-full bg-[#003087]"></div>
              <div class="w-3.5 h-3.5 rounded-full bg-[#0070ba] -ml-1"></div>
            </div>
            <span class="text-[11px] font-bold text-[#003087]">PromptPay</span>
          </div>
        </div>

        <div class="p-5">
          <!-- QR Code Display -->
          <div class="flex justify-center mb-5">
            @if (qrCodeSrc) {
            <div class="p-4 rounded-3xl border border-slate-100 bg-white shadow-sm hover:shadow-md transition-shadow">
              <img [src]="qrCodeSrc" alt="QR Code" (error)="$any($event.target).src='no-image.svg'" class="w-48 h-48 object-contain rounded-xl" />
            </div>
            } @else {
            <div
              class="w-56 h-56 border-2 border-dashed border-slate-200 rounded-3xl flex flex-col items-center justify-center text-slate-400 gap-3 bg-slate-50">
              <span class="material-symbols-outlined text-[48px] text-slate-300">qr_code_2</span>
              <span class="text-sm font-medium text-slate-400">{{ 'ไม่พบ QR Code' | translate : 'payment' }}</span>
            </div>
            }
          </div>

          <!-- Merchant Info -->
          <div class="rounded-2xl bg-slate-50 border border-slate-100 p-3.5 flex items-center justify-between mb-4">
            <div class="flex items-center gap-2.5">
              <div class="w-8 h-8 rounded-full bg-white flex items-center justify-center shadow-sm shrink-0">
                <span class="material-symbols-outlined text-[#003087] text-[16px]">store</span>
              </div>
              <div>
                <div class="text-[10px] text-slate-400 uppercase tracking-wider font-semibold">{{ 'ชื่อทางการค้า' | translate : 'payment' }}</div>
                <div class="text-xs font-bold text-slate-800 truncate">{{ merchantName || ('ไม่ระบุ' | translate : 'payment') }}</div>
              </div>
            </div>
          </div>

          <!-- Save QR Button -->
          <button
            class="w-full flex items-center justify-center gap-2 rounded-2xl border border-blue-200 bg-blue-50 py-3 text-sm font-bold text-blue-700 hover:bg-blue-100 active:scale-[0.98] transition-all"
            (click)="saveQR()">
            <span class="material-symbols-outlined text-[20px]">download</span>
            {{ 'บันทึก QR Code' | translate : 'payment' }}
          </button>
        </div>
      </div>

      <!-- Notice -->
      <div class="rounded-2xl bg-amber-50 border border-amber-100 p-4">
        <div class="flex items-start gap-3">
          <span class="material-symbols-outlined text-amber-500 text-[20px] shrink-0">info</span>
          <div class="text-xs leading-5 text-amber-800">
            {{ 'หลังจากชำระเงินเสร็จสิ้น กรุณากดปุ่ม' | translate : 'payment' }} <span class="font-bold">"{{ 'อัปโหลดหลักฐานการชำระเงิน' | translate : 'payment' }}"</span>
            {{ 'เพื่อยืนยันการทำรายการของคุณ' | translate : 'payment' }}
          </div>
        </div>
      </div>

    </div>

    <!-- Bottom Bar (sticky) -->
    <div
      class="absolute bottom-0 inset-x-0 bg-white/80 backdrop-blur-md border-t border-slate-100 p-5 z-20 shadow-[0_-10px_30px_rgba(0,0,0,0.05)]">
      <button
        class="w-full rounded-2xl bg-blue-600 py-4 text-sm font-bold text-white hover:bg-blue-700 active:scale-[0.98] transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-500/30"
        (click)="toUpload()">
        <span class="material-symbols-outlined text-[20px]">upload_file</span>
        {{ 'อัปโหลดหลักฐานการชำระเงิน' | translate : 'payment' }}
      </button>
    </div>

  </div>
</div>